import React, { useCallback, useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { exportRowsToExcel, exportRowsToPdf } from "./protocolExport";

export default function ProtocolExportButton({ config, size = "small" }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const openMenu = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const closeMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleExport = useCallback(
    (format) => {
      if (!config) return;
      if (format === "excel") exportRowsToExcel(config);
      if (format === "pdf") exportRowsToPdf(config);
      closeMenu();
    },
    [closeMenu, config]
  );

  return (
    <>
      <Button
        onClick={openMenu}
        variant="outlined"
        size={size}
        startIcon={<DownloadRoundedIcon fontSize="small" />}
        sx={{ borderRadius: 2, fontWeight: 900, textTransform: "none" }}
      >
        Download
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { minWidth: 170, borderRadius: 2 } }}
      >
        <MenuItem onClick={() => handleExport("excel")}>Download Excel</MenuItem>
        <MenuItem onClick={() => handleExport("pdf")}>Download PDF</MenuItem>
      </Menu>
    </>
  );
}
